"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isWixDomain = exports.composeHeaders = exports.requestIdOrEmptyString = void 0;
var tslib_1 = require("tslib");
var headers_1 = require("@wix/headers");
var whitelist_json_1 = (0, tslib_1.__importDefault)(require("./whitelist.json"));
var utils_1 = require("./utils");
function requestIdOrEmptyString(response) {
    var _a;
    return ((_a = response === null || response === void 0 ? void 0 : response.headers) === null || _a === void 0 ? void 0 : _a['x-wix-request-id']) || '';
}
exports.requestIdOrEmptyString = requestIdOrEmptyString;
var composeHeaders = function (_a) {
    var url = _a.url, disableWixHeaders = _a.disableWixHeaders, wixHeadersOpts = _a.wixHeadersOpts;
    var shouldAssignWixHeaders = !disableWixHeaders && isWixDomain(url);
    return shouldAssignWixHeaders ? (0, headers_1.createHeaders)(wixHeadersOpts) : {};
};
exports.composeHeaders = composeHeaders;
function isWixDomain(url) {
    var isRelative = !(0, utils_1.isAbsoluteUrl)(url);
    if (isRelative) {
        return true;
    }
    var host = ".".concat((0, utils_1.extractHost)(url));
    var isWhitelisted = whitelist_json_1.default.find(function (wixHost) {
        return host.endsWith(".".concat(wixHost));
    });
    return !!isWhitelisted;
}
exports.isWixDomain = isWixDomain;
//# sourceMappingURL=headers.js.map